[
  {
    "id": "GET-B6-L101-001",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Welk getal komt na 4.999?",
    "options": ["5.000", "4.100", "5.999", "4.000"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "tellen",
    "familyId": "GET-TELLEN",
    "explanation": "Na 4.999 komt 5.000. Je telt er 1 bij op: 9 + 1 = 10, dus het wordt een nieuw duizendtal.",
    "distractorExplanations": {
      "1": "Je telt er 100 bij op in plaats van 1.",
      "2": "Je telt er 1.000 bij op.",
      "3": "Dit is een duizendtal lager."
    }
  },
  {
    "id": "GET-B6-L101-002",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Wat is de helft van 500?",
    "options": ["250", "200", "300", "150"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "delen",
    "familyId": "GET-HELFT",
    "explanation": "De helft van 500 is 250. Want 250 + 250 = 500.",
    "distractorExplanations": {
      "1": "200 + 200 = 400, niet 500.",
      "2": "300 + 300 = 600, dat is te veel.",
      "3": "150 + 150 = 300, dat is te weinig."
    }
  },
  {
    "id": "GET-B6-L101-003",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Welke breuk hoort bij 'een kwart'?",
    "options": ["$\\frac{1}{4}$", "$\\frac{1}{2}$", "$\\frac{1}{3}$", "$\\frac{3}{4}$"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_herkennen",
    "familyId": "GET-BREUK-HERKENNEN",
    "explanation": "Een kwart betekent 1 van de 4 delen. Dat schrijf je als $\\frac{1}{4}$.",
    "distractorExplanations": {
      "1": "Dit is een half.",
      "2": "Dit is een derde.",
      "3": "Dit is drie kwart."
    }
  },
  {
    "id": "GET-B6-L101-004",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Reken uit: 350 + 450 =",
    "options": ["800", "700", "900", "750"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-ZONDER",
    "explanation": "300 + 400 = 700. 50 + 50 = 100. Samen is dat 700 + 100 = 800.",
    "distractorExplanations": {
      "1": "Je bent de 100 van 50+50 vergeten.",
      "2": "Je hebt er 100 te veel bij geteld.",
      "3": "Je hebt een rekenfout gemaakt bij de tientallen."
    }
  },
  {
    "id": "GET-B6-L101-005",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Wat is de waarde van de 3 in 3.420?",
    "options": ["3.000", "300", "30", "3"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "positiewaarde",
    "familyId": "GET-POS-WAARDE",
    "explanation": "De 3 staat op de plek van de duizendtallen. Dus het is 3.000.",
    "distractorExplanations": {
      "1": "Dat zou de plek van de honderdtallen zijn.",
      "2": "Dat zou de plek van de tientallen zijn.",
      "3": "Dat zou de plek van de eenheden zijn."
    }
  },
  {
    "id": "GET-B6-L101-006",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Welk getal komt na 2.099?",
    "options": ["2.100", "2.199", "2.000", "3.000"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "tellen",
    "familyId": "GET-TELLEN",
    "explanation": "Na 2.099 komt 2.100. De 99 wordt 100, dus het honderdtal gaat omhoog.",
    "distractorExplanations": {
      "1": "Je telde er 100 bij op in plaats van 1.",
      "2": "Dit is 100 lager.",
      "3": "Dit is een heel duizendtal verder."
    }
  },
  {
    "id": "GET-B6-L101-007",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Tel verder: 3.500, 4.000, 4.500, ...",
    "options": ["5.000", "4.600", "5.500", "4.550"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "tellen",
    "familyId": "GET-TELLEN-REEKS",
    "explanation": "Je telt steeds 500 erbij op. 4.500 + 500 = 5.000.",
    "distractorExplanations": {
      "1": "Je telde er maar 100 bij op.",
      "2": "Je telde er 1.000 bij op.",
      "3": "Je telde er maar 50 bij op."
    }
  },
  {
    "id": "GET-B6-L101-008",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Wat is de helft van 80?",
    "options": ["40", "60", "20", "50"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "delen",
    "familyId": "GET-HELFT",
    "explanation": "De helft van 80 is 40. Want 40 + 40 = 80.",
    "distractorExplanations": {
      "1": "60 + 60 = 120, dat is te veel.",
      "2": "20 + 20 = 40, dat is te weinig.",
      "3": "50 + 50 = 100, dat is te veel."
    }
  },
  {
    "id": "GET-B6-L101-009",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Wat is het dubbele van 150?",
    "options": ["300", "200", "250", "350"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "vermenigvuldigen",
    "familyId": "GET-DUBBEL",
    "explanation": "Het dubbele van 150 is 150 + 150 = 300.",
    "distractorExplanations": {
      "1": "Dat is het dubbele van 100.",
      "2": "Dat is 150 + 100.",
      "3": "Dat is 150 + 200."
    }
  },
  {
    "id": "GET-B6-L101-010",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Welke breuk hoort bij 'de helft'?",
    "options": ["$\\frac{1}{2}$", "$\\frac{1}{4}$", "$\\frac{1}{3}$", "$\\frac{2}{4}$"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_herkennen",
    "familyId": "GET-BREUK-HERKENNEN",
    "explanation": "De helft betekent 1 van de 2 delen. Dat schrijf je als $\\frac{1}{2}$.",
    "distractorExplanations": {
      "1": "Dit is een kwart, dat is minder dan de helft.",
      "2": "Dit is een derde.",
      "3": "$\\frac{2}{4}$ is ook een half, maar $\\frac{1}{2}$ is de standaardnotatie."
    }
  },
  {
    "id": "GET-B6-L101-011",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Hoeveel is $\\frac{1}{2}$ van 10?",
    "options": ["5", "2", "10", "8"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "De helft van 10 is 5. Want 10 : 2 = 5.",
    "distractorExplanations": {
      "1": "Dat is een vijfde van 10.",
      "2": "Dat is het hele getal.",
      "3": "Dat is te veel."
    }
  },
  {
    "id": "GET-B6-L101-012",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Reken uit: 125 + 275 =",
    "options": ["400", "300", "350", "500"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-ZONDER",
    "explanation": "100 + 200 = 300. 25 + 75 = 100. Samen is dat 300 + 100 = 400.",
    "distractorExplanations": {
      "1": "Je bent de 100 van 25+75 vergeten.",
      "2": "Je hebt een rekenfout gemaakt.",
      "3": "Dat is te veel."
    }
  },
  {
    "id": "GET-B6-L101-013",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Reken uit: 600 + 250 =",
    "options": ["850", "750", "900", "650"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-ZONDER",
    "explanation": "600 + 200 = 800. 800 + 50 = 850.",
    "distractorExplanations": {
      "1": "Je bent de 50 vergeten.",
      "2": "Je telde er 300 bij op in plaats van 250.",
      "3": "Je telde er maar 50 bij op."
    }
  },
  {
    "id": "GET-B6-L101-014",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Wat is de waarde van de 7 in 1.750?",
    "options": ["700", "7.000", "70", "7"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "positiewaarde",
    "familyId": "GET-POS-WAARDE",
    "explanation": "De 7 staat op de plek van de honderdtallen. Dus het is 700.",
    "distractorExplanations": {
      "1": "Dat zou de plek van de duizendtallen zijn.",
      "2": "Dat zou de plek van de tientallen zijn.",
      "3": "Dat zou de plek van de eenheden zijn."
    }
  },
  {
    "id": "GET-B6-L101-015",
    "module": "Getalbegrip",
    "difficulty": 101,
    "question": "Welk getal is het grootst?",
    "options": ["4.200", "2.400", "2.040", "420"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "getallen_vergelijken",
    "familyId": "GET-GETAL-VGL",
    "explanation": "4.200 is het grootst. Het heeft 4 duizendtallen, de andere getallen hebben er minder.",
    "distractorExplanations": {
      "1": "2.400 heeft maar 2 duizendtallen.",
      "2": "2.040 heeft maar 2 duizendtallen.",
      "3": "420 heeft geen duizendtallen."
    }
  }
]